module.exports = __webpack_public_path__ + "static/media/illustration2.283f78f0.svg";